const ImageHotels = [
  {
    id: 1,
    link: "https://www.booking.com/hotel/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/xdata/images/xphoto/square300/57584488.webp?k=bf724e4e9b9b75480bbe7fc675460a089ba6414fe4693b83ea3fdd8e938832a6&o=",
    title: "Hotels",
    propertyCount: "855,306 hotels",
  },
  {
    id: 2,
    link: "https://www.booking.com/apartments/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/card-image-apartments_300/9f60235dc09a3ac3f0a93adbc901c61ecd1ce72e.jpg",
    title: "Apartments",
    propertyCount: "800,375 apartments",
  },
  {
    id: 3,
    link: "https://www.booking.com/resorts/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_resorts/6f87c6143fbd51a0bb5d15ca3b9cf84211ab0884.jpg",
    title: "Resorts",
    propertyCount: "17,718 resorts",
  },
  {
    id: 4,
    link: "https://www.booking.com/villas/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/card-image-villas_300/dd0d7f8202676306a661aa4f0cf1ffab31286211.jpg",
    title: "Villas",
    propertyCount: "419,970 villas",
  },
  {
    id: 5,
    link: "https://www.booking.com/chalet/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/card-image-chalet_300/8ee014fcc493cb3334e25893a1dee8c6d36ed0ba.jpg",
    title: "Cabins",
    propertyCount: "33,287 cabins",
  },
  {
    id: 6,
    link: "https://www.booking.com/cottages/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_cottages/5e1fd9cd716f4825c6c7eac5abe692c52cc64516.jpg",
    title: "Cottages",
    propertyCount: "140,927 cottages",
  },
  {
    id: 7,
    link: "https://www.booking.com/glamping/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_glamping/6e181b9e942c160f4605239be7ddc1728cbcc4c8.jpg",
    title: "Glamping",
    propertyCount: "11,475 Glamping Sites",
  },
  {
    id: 8,
    link: "https://www.booking.com/aparthotels/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_aparthotel/10e092f390b128dcff92727912299eef7824b751.jpg",
    title: "Serviced Apartments",
    propertyCount: "33,029 serviced apartments",
  },
  {
    id: 9,
    link: "https://www.booking.com/holiday-homes/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/card-image-holidayhomes_300/604c7484d34a9e8791c2d5a0e2df4bc8c803dc7c.jpg",
    title: "Vacation Homes",
    propertyCount: "419,970 vacation homes",
  },
  {
    id: 10,
    link: "https://www.booking.com/guest-house/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_guest_house/70618d86d515349ce56296a56d2eaaf283fd1542.jpg",
    title: "Guest houses",
    propertyCount: "101,021 guest houses",
  },
  {
    id: 11,
    link: "https://www.booking.com/hostels/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_hostels/cd5489c0d29025a9ca9daa602ac1581ba042bc69.jpg",
    title: "Hostels",
    propertyCount: "16,265 hostels",
  },
  {
    id: 12,
    link: "https://www.booking.com/motels/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_motels/9673cd1b55cbc1e1cdaeae09d87d16aa9d84d5f7.jpg",
    title: "Motels",
    propertyCount: "13,005 motels",
  },
  {
    id: 13,
    link: "https://www.booking.com/bed-and-breakfast/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_bed_and_breakfast/a6a4a3f904284337c187771d94a4bb6169b168d7.jpg",
    title: "B&Bs",
    propertyCount: "195,654 B&Bs",
  },
  {
    id: 14,
    link: "https://www.booking.com/ryokans/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_ryokans/e4f002b9907a13a55b4e10b85fdd5d8ea436eb2d.jpg",
    title: "Ryokans",
    propertyCount: "2,051 ryokans",
  },
  {
    id: 15,
    link: "https://www.booking.com/riad/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_riad/ec1ea267f18d830b68ca76a666734f8e93a1853d.jpg",
    title: "Riads",
    propertyCount: "1,185 riads",
  },
  {
    id: 16,
    link: "https://www.booking.com/holiday-parks/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_holidaypark/891162048c0a9c104752ed3c4462f2c230e2fabc.jpg",
    title: "Resort Villages",
    propertyCount: "5,537 resort villages",
  },
  {
    id: 17,
    link: "https://www.booking.com/homestay/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_home_stay/9499c7a4ab5a599218da6d49422dae03384013e3.jpg",
    title: "Homestays",
    propertyCount: "133,099 homestays",
  },
  {
    id: 18,
    link: "https://www.booking.com/campings/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_campsite/6d40bef46964b8841a84cd88793fc8f0fa6663d9.jpg",
    title: "Campgrounds",
    propertyCount: "8,606 campgrounds",
  },
  {
    id: 19,
    link: "https://www.booking.com/country-houses/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_country_house/6ffa05069b50124c993f00c998f1dfc66999c93f.jpg",
    title: "Country Houses",
    propertyCount: "11,846 country houses",
  },
  {
    id: 20,
    link: "https://www.booking.com/farm-holidays/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_farmhouses/9aeedf4b943c722367e5e901681463bf543c5afd.jpg",
    title: "Farm Stays",
    propertyCount: "10,600 farm stays",
  },
  {
    id: 21,
    link: "https://www.booking.com/boats/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_boats/5b974434f444153092a0249af70b3678c2e22e7c.jpg",
    title: "Boats",
    propertyCount: "1,345 boats",
  },
  {
    id: 22,
    link: "https://www.booking.com/camp/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_tented_camp/adf0677a5fd80032dc577fad07ad528312dfcadf.jpg",
    title: "Luxury Tents",
    propertyCount: "3,497 luxury tents",
  },
  {
    id: 23,
    link: "https://www.booking.com/self-catering/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_self-catering/7a0939f5a5338faf255840e895953a522335434a.jpg",
    title: "Self-catering Accommodations",
    propertyCount: "707,438 Self-catering Properties",
  },
  {
    id: 24,
    link: "https://www.booking.com/tiny-house/index.html?aid=356980&label=gog235jc-1DCAIoqwFCAm5wSDNYA2irAYgBAZgBMbgBF8gBDNgBA-gBAfgBAogCAagCA7gCyYKYkwbAAgHSAiQ3NTJkNmRhYy0xNWYxLTQwYzQtYWQ2My03NzM4OTBjYzRjMDfYAgTgAgE&sid=ede707d0a43fe7e06f23e5a85adebe82&from_booking_home_promotion=1&srpvid=ce6c0e6f22ef00a4&",
    img: "https://cf.bstatic.com/static/img/theme-index/carousel_320x240/bg_tiny_house/953faca2af408d667f469ecd3d2b4f1687d7b07f.jpg",
    title: "Tiny houses",
    propertyCount: "452 tiny houses",
  },
];

export default ImageHotels;
